import React, { useEffect, useRef } from 'react';
import arrowRight from '../../assets/icons/arrow-right.svg';
import dotsIcon from '../../assets/icons/dots-icon.svg';

interface PaginationProps {
  rowsLength: number;
  pageCount: number;
  pageIndex: number;
  pageSize: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  gotoPage: (page: number) => void;
  previousPage: () => void;
  nextPage: () => void;
  setPageSize: (size: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  rowsLength,
  pageCount,
  pageIndex,
  pageSize,
  canPreviousPage,
  canNextPage,
  gotoPage,
  previousPage,
  nextPage,
  setPageSize,
}) => {
  let paginationRowsArray: Array<number> = [];
  if (rowsLength > 50) paginationRowsArray = [50, rowsLength];
  if (rowsLength > 100) paginationRowsArray = [50, 100, rowsLength];
  if (rowsLength > 200) paginationRowsArray = [50, 100, 200, rowsLength];
  if (rowsLength > 300) paginationRowsArray = [50, 100, 200, 300, rowsLength];
  if (rowsLength > 500) paginationRowsArray = [50, 100, 200, 300, 500];

  let buttons = [];

  const bottomRef = useRef<HTMLDivElement | null>(null);

  const isInitialMount = useRef(true);

  useEffect(() => {
    // console.log(isInitialMount.current);
    if (!isInitialMount.current) {
      bottomRef.current?.scrollIntoView({ behavior: 'instant' });
    }
  }, [pageIndex]);

  const setInitialMaountToFalse = () => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    }
  };

  for (let i = 1; i <= pageCount; i++) {
    if (pageCount <= 1) return null;
    else if (pageCount > 1 && pageCount <= 7) {
      ///prikazi sve
      buttons.push(
        <button
          className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
          onClick={() => {
            gotoPage(i - 1);
            setInitialMaountToFalse();
          }}
          key={i}
        >
          {i}
        </button>
      );
    } else {
      if (pageIndex <= 3) {
        if (i <= 5) {
          buttons.push(
            <button
              className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
              onClick={() => {
                gotoPage(i - 1);
                setInitialMaountToFalse();
              }}
              key={i}
            >
              {i}
            </button>
          );
        }
        if (i === pageCount) {
          buttons.push(
            <React.Fragment key={i}>
              <button className='pagination-button border-none' disabled>
                <img src={dotsIcon} alt='...' />
              </button>
              <button
                className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
                onClick={() => {
                  gotoPage(i - 1);
                  setInitialMaountToFalse();
                }}
              >
                {i}
              </button>
            </React.Fragment>
          );
        }
      } else if (pageIndex >= pageCount - 4) {
        if (i === 1) {
          buttons.push(
            <React.Fragment key={i}>
              <button
                className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
                onClick={() => {
                  gotoPage(i - 1);
                  setInitialMaountToFalse();
                }}
              >
                {i}
              </button>
              <button className='pagination-button border-none' disabled>
                <img src={dotsIcon} alt='...' />
              </button>
            </React.Fragment>
          );
        }
        if (i >= pageCount - 4) {
          buttons.push(
            <button
              className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
              onClick={() => {
                gotoPage(i - 1);
                setInitialMaountToFalse();
              }}
              key={i}
            >
              {i}
            </button>
          );
        }
      } else {
        if (i === 1) {
          buttons.push(
            <React.Fragment key={i}>
              <button
                className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
                onClick={() => {
                  gotoPage(i - 1);
                  setInitialMaountToFalse();
                }}
              >
                {i}
              </button>
              <button className='pagination-button border-none' disabled>
                <img src={dotsIcon} alt='...' />
              </button>
            </React.Fragment>
          );
        }
        if (i === pageIndex || i === pageIndex + 1 || i === pageIndex + 2) {
          buttons.push(
            <button
              className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
              onClick={() => {
                gotoPage(i - 1);
                setInitialMaountToFalse();
              }}
              key={i}
            >
              {i}
            </button>
          );
        }
        if (i === pageCount) {
          buttons.push(
            <React.Fragment key={i}>
              <button className='pagination-button border-none' disabled>
                <img src={dotsIcon} alt='...' />
              </button>
              <button
                className={`pagination-button ${pageIndex + 1 === i ? 'selected' : ''}`}
                onClick={() => {
                  gotoPage(i - 1);
                  setInitialMaountToFalse();
                }}
              >
                {i}
              </button>
            </React.Fragment>
          );
        }
      }
    }
  }

  return (
    <div className='pagination' ref={bottomRef}>
      <div className='pagination__empty-element'></div>

      <div className='pagination__main'>
        <button
          className='pagination-button'
          onClick={() => {
            previousPage();
            setInitialMaountToFalse();
          }}
          disabled={!canPreviousPage}
        >
          <img className='transform-05' src={arrowRight} alt='previous page' />
        </button>
        {buttons}
        <button
          className='pagination-button'
          onClick={() => {
            nextPage();
            setInitialMaountToFalse();
          }}
          disabled={!canNextPage}
        >
          <img src={arrowRight} alt='next page' />
        </button>
      </div>

      <select
        className='pagination__dropdown'
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
          setInitialMaountToFalse;
        }}
      >
        {[...paginationRowsArray].map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            Showing {pageSize} of {rowsLength}
          </option>
        ))}
      </select>
    </div>
  );
};
{
  /* Pozivanje paginacije:

    <Pagination
        rowsLength={rows.length}
        pageCount={pageCount}
        pageIndex={pageIndex}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        nextPage={nextPage}
        setPageSize={setPageSize}
    /> */
}
